import api from '../../api';
import store from '../../store';
import { setCompany } from '../../store/app';

export const viewCompany = async (id, params) => {
  const res = await api.get('/companies/' + id, params);

  store.dispatch(setCompany(res.data.company));

  return res;
};

export const updateCompany = async (id, data) => {
  const res = await api.patch('/companies/' + id, data);

  // store.dispatch(setCompany(res.data.company));

  return res;
};

export const uploadCompany = async (id, data, config?: any) => {
  const { data: company } = await api.put('/companies/' + id + '/upload', data, config);

  store.dispatch(setCompany(company));

  return company;
};

export const activateImageURL = async (
  companyId: string,
  data: { imageName: string; section: string },
  config?: any
) => {
  const { data: company } = await api.post(
    '/companies/' + companyId + '/media/activate',
    data,
    config
  );

  store.dispatch(setCompany(company));

  return company;
};

export const deleteImage = async (
  companyId: string,
  data: { filename: string; type: string },
  config?: any
) => {
  const { data: result } = await api.put('/companies/' + companyId + '/media/delete', data, config);

  store.dispatch(setCompany(result.company));

  return result;
};

export const activateHexCode = async (
  companyId: string,
  data: { hex_code: string },
  config?: any
) => {
  const { data: company } = await api.post(
    '/companies/' + companyId + '/color/activate',
    data,
    config
  );

  store.dispatch(setCompany(company));

  return company;
};

export const deleteHexCode = async (
  companyId: string,
  data: { hex_code: string },
  config?: any
) => {
  const company = await api.put('/companies/' + companyId + '/color/delete', data, config);

  store.dispatch(setCompany(company));
  return company;
};

export const isCompanyInit = () => api.get('/companies/init');
export const setupApp = (data) => api.post('/companies/init', data);
